import {
  Input as ChakraInput,
  InputProps as ChakraInputProps,
  FormControl,
  FormLabel,
  IconButton,
  InputGroup,
  InputRightElement,
  FormHelperText,
} from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { useState, FC } from "react";
import { Field } from "formik";

interface InputProps extends ChakraInputProps {
  label?: string;
  isShowPasswordIcon?: boolean;
  isRequiredField?: boolean;
  helpText?: string;
}

const Input: FC<InputProps> = ({ label, isShowPasswordIcon, isRequiredField, helpText, ...inputProps }) => {
  const [isShowPassword, setShowPassword] = useState(false);

  return (
    <FormControl isRequired={isRequiredField} mt={4}>
      {label && <FormLabel>{label}</FormLabel>}
      <InputGroup size="md">
        <Field
          as={ChakraInput}
          {...inputProps}
          _focusVisible={{ boxShadow: "transparent" }}
          type={isShowPassword ? "text" : inputProps.type}
          bg="brand.inputBg"
          borderRadius="base"
          color="brand.black"
          _placeholder={{ color: "brand.placeholder" }}
          border="none"
        />
        {isShowPasswordIcon && (
          <InputRightElement>
            <IconButton
              aria-label={isShowPassword ? "Hide password" : "Show password"}
              icon={isShowPassword ? <ViewOffIcon /> : <ViewIcon />}
              onClick={() => setShowPassword(!isShowPassword)}
            />
          </InputRightElement>
        )}
      </InputGroup>
      {helpText && <FormHelperText>{helpText}</FormHelperText>}
    </FormControl>
  );
};

export default Input;
